/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UICustomizationChallengeOptions
 */
export interface UICustomizationChallengeOptions {
    /**
     * UI configuration for the hosted page users are redirected to after clicking a magic link or password reset link.
     * @type {{ [key: string]: any; }}
     * @memberof UICustomizationChallengeOptions
     */
    authn_redirect_page_ui_config?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UICustomizationChallengeOptions interface.
 */
export function instanceOfUICustomizationChallengeOptions(value: object): value is UICustomizationChallengeOptions {
    return true;
}

export function UICustomizationChallengeOptionsFromJSON(json: any): UICustomizationChallengeOptions {
    return UICustomizationChallengeOptionsFromJSONTyped(json, false);
}

export function UICustomizationChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UICustomizationChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'authn_redirect_page_ui_config': json['authn_redirect_page_ui_config'] == null ? undefined : json['authn_redirect_page_ui_config'],
    };
}

export function UICustomizationChallengeOptionsToJSON(json: any): UICustomizationChallengeOptions {
    return UICustomizationChallengeOptionsToJSONTyped(json, false);
}

export function UICustomizationChallengeOptionsToJSONTyped(value?: UICustomizationChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authn_redirect_page_ui_config': value['authn_redirect_page_ui_config'],
    };
}

